import React from 'react';
import { FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalTemplate} from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowUSIntakeClinicalInformationModalStore')
@observer
class FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeClinicalInformationModal;
